/**
 * 由 scripts/gen_frame_and_validate.mjs 生成，请勿手改。
 * 来源：character_00.fbx（node 实测 65 骨、无重名副本的干净 Mixamo 导出）经
 * FBXLoader 解析后的逐骨静止四元数 —— 即 977 姿势库所在的"标准 FBX 局部系"。
 * 用途：GLB/FBX 运行时按 E_b = rest_bone ∘ std⁻¹ 修正逐骨坐标系差（Blender
 * 导出对个别骨（如 Hips）有 90° 轴修正，node 数值验证见 frame_validation.json）。
 */
export const STD_FBX_REST: Readonly<Record<string, readonly [number, number, number, number]>> = {
  "mixamorigHips": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigRightUpLeg": [0.00148803, -0.03319830, 0.99844522, 0.04475273],
  "mixamorigRightLeg": [0.01409664, 0.00001850, 0.00131214, 0.99989978],
  "mixamorigRightFoot": [0.49193816, -0.05141631, 0.02911926, 0.86862263],
  "mixamorigRightToeBase": [0.31150062, 0.02803985, -0.00919620, 0.94978764],
  "mixamorigRightToe_End": [0.00000000, 0.00000000, -0.00000000, 1.00000000],
  "mixamorigLeftUpLeg": [-0.00180584, -0.04033109, 0.99818464, -0.04469411],
  "mixamorigLeftLeg": [0.02368665, -0.00002906, -0.00122639, 0.99971868],
  "mixamorigLeftFoot": [0.48698964, 0.05195879, -0.02903840, 0.87137715],
  "mixamorigLeftToeBase": [0.31511299, -0.02797857, 0.00929417, 0.94859613],
  "mixamorigLeftToe_End": [-0.00000000, -0.00000000, -0.00000000, 1.00000000],
  "mixamorigSpine": [-0.02570708, 0.00000000, 0.00000000, 0.99966952],
  "mixamorigSpine1": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigSpine2": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigNeck": [0.02570708, 0.00000000, 0.00000000, 0.99966952],
  "mixamorigHead": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigHeadTop_End": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigLeftShoulder": [-0.55670391, -0.43461032, 0.56187355, -0.43068867],
  "mixamorigLeftArm": [-0.09474598, 0.00390906, -0.04103745, 0.99464760],
  "mixamorigLeftForeArm": [-0.05880368, -0.00386021, 0.06539081, 0.99611810],
  "mixamorigLeftHand": [0.04443983, 0.00353353, -0.00568945, 0.99898961],
  "mixamorigLeftHandMiddle1": [0.02032414, 0.00015567, 0.00765763, 0.99976410],
  "mixamorigLeftHandMiddle2": [0.10104584, -0.00000000, 0.00000000, 0.99488177],
  "mixamorigLeftHandMiddle3": [0.01677890, 0.00000000, -0.00000000, 0.99985922],
  "mixamorigLeftHandMiddle4": [-0.00000001, -0.00000000, -0.00000000, 1.00000000],
  "mixamorigLeftHandRing1": [0.01870067, -0.00058940, -0.03149668, 0.99932872],
  "mixamorigLeftHandRing2": [0.13012362, 0.00000000, 0.00000000, 0.99149778],
  "mixamorigLeftHandRing3": [-0.05147259, 0.00000000, 0.00000000, 0.99867441],
  "mixamorigLeftHandRing4": [0.00000001, -0.00000000, -0.00000000, 1.00000000],
  "mixamorigLeftHandPinky1": [0.01788502, -0.00004520, -0.00252697, 0.99983686],
  "mixamorigLeftHandPinky2": [0.09990139, 0.00000000, -0.00000000, 0.99499734],
  "mixamorigLeftHandPinky3": [-0.05958728, -0.00000000, -0.00000000, 0.99822310],
  "mixamorigLeftHandPinky4": [0.00000000, 0.00000000, -0.00000000, 1.00000000],
  "mixamorigLeftHandThumb1": [0.14669699, 0.04908552, 0.31349321, 0.93690587],
  "mixamorigLeftHandThumb2": [0.05491491, -0.00000000, -0.00000000, 0.99849104],
  "mixamorigLeftHandThumb3": [-0.11712737, 0.00000000, -0.00000000, 0.99311690],
  "mixamorigLeftHandThumb4": [0.00000000, 0.00000000, -0.00000000, 1.00000000],
  "mixamorigLeftHandIndex1": [0.01305662, 0.00023493, 0.01798830, 0.99975291],
  "mixamorigLeftHandIndex2": [0.08475359, 0.00000000, 0.00000000, 0.99640194],
  "mixamorigLeftHandIndex3": [0.02584683, 0.00000000, -0.00000000, 0.99966592],
  "mixamorigLeftHandIndex4": [0.00000002, -0.00000000, -0.00000000, 1.00000000],
  "mixamorigRightShoulder": [0.55423388, -0.43652192, 0.56412494, 0.42899472],
  "mixamorigRightArm": [-0.09453343, -0.00323191, 0.03401485, 0.99493516],
  "mixamorigRightForeArm": [-0.05861049, 0.00381559, -0.06485116, 0.99616494],
  "mixamorigRightHand": [0.04254794, -0.01185680, 0.01000448, 0.99897397],
  "mixamorigRightHandPinky1": [0.03093952, 0.00092748, 0.02994947, 0.99907203],
  "mixamorigRightHandPinky2": [0.08685679, -0.00000000, 0.00000000, 0.99622081],
  "mixamorigRightHandPinky3": [-0.01483230, -0.00000000, -0.00000000, 0.99989000],
  "mixamorigRightHandPinky4": [-0.00000001, 0.00000000, -0.00000000, 1.00000000],
  "mixamorigRightHandRing1": [0.06013053, 0.00177903, 0.02951963, 0.99775235],
  "mixamorigRightHandRing2": [0.08860979, 0.00000000, 0.00000000, 0.99606642],
  "mixamorigRightHandRing3": [-0.08945922, -0.00000000, 0.00000000, 0.99599049],
  "mixamorigRightHandRing4": [0.00000002, -0.00000000, -0.00000000, 1.00000000],
  "mixamorigRightHandThumb1": [0.14534854, -0.04639985, -0.30055109, 0.94148282],
  "mixamorigRightHandThumb2": [0.05659559, 0.00000000, 0.00000000, 0.99839718],
  "mixamorigRightHandThumb3": [-0.15679416, -0.00000000, -0.00000000, 0.98763130],
  "mixamorigRightHandThumb4": [0.00000000, 0.00000000, 0.00000000, 1.00000000],
  "mixamorigRightHandIndex1": [0.00948524, -0.00024141, -0.02544178, 0.99963128],
  "mixamorigRightHandIndex2": [0.09081845, 0.00000000, 0.00000000, 0.99586747],
  "mixamorigRightHandIndex3": [0.05608750, 0.00000000, -0.00000000, 0.99842586],
  "mixamorigRightHandIndex4": [-0.00000000, 0.00000000, -0.00000000, 1.00000000],
  "mixamorigRightHandMiddle1": [0.01173779, 0.00003672, 0.00312792, 0.99992622],
  "mixamorigRightHandMiddle2": [0.11765505, -0.00000000, 0.00000000, 0.99305453],
  "mixamorigRightHandMiddle3": [-0.02892744, 0.00000000, -0.00000000, 0.99958151],
  "mixamorigRightHandMiddle4": [0.00000001, 0.00000000, -0.00000000, 1.00000000],
};
